module.exports = __webpack_public_path__ + "img/gtco.189617ac.svg";